// extracted by mini-css-extract-plugin
module.exports = {"columns-3":"1700","columns-2":"1550","columns-1":"1350","tableHeaderLine":"TableHeader_tableHeaderLine__Paq0o","tableHeaderText":"TableHeader_tableHeaderText__3GWcV"};